import { webApi } from '@mi-front/api-clients';

const PUBLISHED_PLATFORM_DISPLAY_STATUSES = ['COMPLETED', 'FAILED'] as const;

/** Platform row for social-export `UploadedPlatformsStatus` when driven from edit `publishedPlatforms` only. */
export type PublishedPlatformDisplayItem = { id: string; platform: string; status: string };

/**
 * Maps video editor published platform entries to display items (COMPLETED/FAILED only).
 * Used by edit card media overlay when showing platform pills from list payload.
 */
export function getPublishedPlatformDisplayItems(
  publishedPlatforms: webApi.EnrichedVideoEditorEditListItemDto['publishedPlatforms'],
): PublishedPlatformDisplayItem[] {
  if (!publishedPlatforms?.length) return [];
  return publishedPlatforms
    .filter((p) =>
      PUBLISHED_PLATFORM_DISPLAY_STATUSES.includes(
        p.status as (typeof PUBLISHED_PLATFORM_DISPLAY_STATUSES)[number],
      ),
    )
    .map((p) => ({ id: p.uploadId, platform: p.platform, status: p.status }));
}
